<template lang="html">
	<div id="app" class="main column no-header">
		<div class="background-login"></div>
		<div class="active login enterprise-subscriptions">
			<div class="ctn-img-login row">
				<img src="~@/common/assets/img/logo-patrim.svg" alt="">
			</div>
			<form class="form-ui column" novalidate>
				<div class="ctn-duo-input row">
					<div class="form-elem-container left">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('raison sociale')}">
							<label for="raison sociale">Raison sociale</label>
							<input v-validate="'required'" type="text" name="raison sociale" v-model="user.name">
						</div>
						<div v-if="errors.has('raison sociale')" class="error-message">{{ errors.first('raison sociale') }}</div>
					</div>
					<div class="form-elem-container right">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('numéro de siret')}">
							<label for="numéro de siret">N°SIRET</label>
							<input v-validate="'required|numeric'" type="text" name="numéro de siret" v-model="user.siret">
						</div>
						<div v-if="errors.has('numéro de siret')" class="error-message">{{ errors.first('numéro de siret') }}</div>
					</div>
				</div>
				<div class="ctn-duo-input row">
					<div class="form-elem-container left">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('téléphone')}">
							<label for="téléphone">Téléphone</label>
							<input v-validate="'required'" type="text" name="téléphone" v-model="user.phone">
						</div>
						<div v-if="errors.has('téléphone')" class="error-message">{{ errors.first('téléphone') }}</div>
					</div>
					<div class="form-elem-container right">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('adresse e-mail')}">
							<label for="adresse e-mail">E-mail</label>
							<input v-validate="'required'" type="text" name="adresse e-mail" v-model="user.email">
						</div>
						<div v-if="errors.has('adresse e-mail')" class="error-message">{{ errors.first('adresse e-mail') }}</div>
					</div>
				</div>
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('mot de passe')}">
						<label for="mot de passe">Mot de passe</label>
						<input v-validate="'required'" type="password" name="mot de passe" v-model="user.password">
					</div>
					<div v-if="errors.has('mot de passe')" class="error-message">{{ errors.first('mot de passe') }}</div>
				</div>
				<div class="form-elem-container">
					<div class="check-container row">
						<radio-box :value="user.acceptDER" @change="setDer" />
						<div class="link">
							Je confirme avoir connaissance des informations de DER
						</div>
					</div>
					<div v-if="customError.der" class="error-message">Vous devez prendre connaissance des DER</div>
				</div>
				<div class="form-elem-container">
					<div class="check-container row">
						<radio-box :value="user.acceptCGU" @change="setCgu" />
						<a href="https://www.patrimoffice.com/cgu/" class="link" target="_blank">
							J'accepte les CGU
						</a>
					</div>
					<div v-if="customError.cgu" class="error-message">Vous devez accepter les CGU</div>
				</div>
			</form>
			<div class="ctn-connect">
				<div class="light btn btn-red" @click="register">
					Suivant
				</div>
			</div>
			<router-link class="ctn-password-reset link" :to="{name: 'Login'}">
				Vous avez déjà un compte ? Vous connecter
			</router-link>
			<router-link class="ctn-password-reset link" :to="{name: 'AnonymousSubscribe'}">
				Accès anonyme
			</router-link>
		</div>
	</div>
</template>

<script>
import UserResource from '@/resources/User'
export default {
	name: 'EnterpriseSubscribe',
	data () {
		return {
			user: {
				name: null,
				siret: null,
				phone: null,
				email: null,
				password: null,
				acceptCGU: null,
				acceptDER: null
			},
			customError: {
				cgu: false,
				der: false
			}
		}
	},
	methods: {
		register () {
			this.$validator.validate().then((validation) => {
				if (validation && this.user.acceptCGU && this.user.acceptDER) {
					UserResource.registerEnterprise(this.user).then((success) => {
						this.$notify({
							type: 'success',
							group: 'default',
							title: 'Votre compte a été crée avec succès',
							text: 'Un email vous a été envoyé afin de valider votre compte'
						})
						this.$router.push({name: 'Login'})
					}).catch((error) => {
						console.warn(error)
						this.$notify({
							type: 'error',
							group: 'default',
							title: 'Une erreur est survenue',
							text: 'Veuillez vérifier les informations que vous avez donné'
						})
					})
				} else {
					this.customError.cgu = !this.user.acceptCGU
					this.customError.der = !this.user.acceptDER
				}
			})
		},
		setCgu (val) {
			this.user.acceptCGU = val
			if (val) this.customError.cgu = false
		},
		setDer (val) {
			this.user.acceptDER = val
			if (val) this.customError.der = false
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/views/Auth/EnterpriseSubscribe.vue